import { EmptyLayout } from '@strategicclaimsmassarb/modules/layout/templates';
import { IndexPage } from '@strategicclaimsmassarb/pages';

import type { RedirectRoute, RouteProps } from '@config/routes';

type AvailableRoutes = 'index';

type ConfigRoutes = Record<AvailableRoutes, RouteProps>;

const routes: ConfigRoutes = {
    index: {
        name: 'index',
        title: 'Strategic-Claims Mass-Arb',
        path: '/',
        Component: IndexPage,
        LayoutComponent: EmptyLayout,
    },
};

const redirects: RedirectRoute[] = [];

export { routes, redirects };
